/**
 * 팀 안전성 검증 관련 함수들
 */

import { createBrowserClient } from '@/supabase'
import { TEAM_MEMBER_STATUS, logTeamService } from '@/utils/team-helpers'

/**
 * 팀 삭제 전 안전성 검증
 */
export const checkTeamDeletionSafety = async (teamId: number) => {
  const supabase = createBrowserClient()

  // 팀원 수 확인
  const { count: memberCount, error: memberError } = await supabase
    .from('team_members')
    .select('*', { count: 'exact', head: true })
    .eq('team_id', teamId)
    .eq('status', TEAM_MEMBER_STATUS.ACTIVE)

  if (memberError) {
    logTeamService('warn', 'checkTeamDeletionSafety', { error: memberError, teamId, type: 'memberCount' })
  }

  // 진행 중인 프로젝트 확인 (SUBMITTED, ACCEPTED 상태) - 새 스키마 사용
  const { count: projectCount, error: projectError } = await supabase
    .from('estimates' as any)
    .select('*', { count: 'exact', head: true })
    .eq('proposer_type', 'TEAM')
    .eq('proposer_team_id', teamId)
    .in('status', ['SUBMITTED', 'ACCEPTED'])

  if (projectError) {
    logTeamService('warn', 'checkTeamDeletionSafety', {
      error: projectError,
      teamId,
      type: 'projectCount',
    })
  }

  const warnings: string[] = []
  const memberCountValue = memberCount || 0
  const projectCountValue = projectCount || 0

  if (memberCountValue > 0) {
    warnings.push(`팀원 ${memberCountValue}명이 팀에 속해 있습니다.`)
  }

  if (projectCountValue > 0) {
    warnings.push(`진행 중인 프로젝트 ${projectCountValue}개가 있습니다.`)
  }

  return {
    canDelete: true, // 검증은 하지만 삭제는 가능 (경고만 표시)
    memberCount: memberCountValue,
    projectCount: projectCountValue,
    warnings,
  }
}

